export const obtenerObjLocal = ({key}) => {

    let objString = window.localStorage.getItem(key)
    return JSON.parse(objString)


}